var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgUserBrand = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 474.75,
    height: 128.641,
    viewBox: "0 0 474.75 128.641",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#00bbaf;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:2.402px;}.c{fill:#fff;}.d{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 474.75,
    height: 128.641,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.057,
    dy: 3.793,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.161,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.651
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.425 5.689)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "matrix(1, 0, 0, 1, -4.43, -5.69)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1032.846,223.378H684.939L631,278.216l53.939,54.838h347.907l53.939-51.242Z",
    transform: "translate(-626.57 -217.69)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 60.36,
    height: 60.36,
    transform: "translate(68.109 96.834) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 12.714,
    height: 12.714,
    transform: "translate(424.535 67.638) rotate(-135)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M743.523,238.549h310.15l42.252,47.646-42.252,39.555H743.523",
    transform: "translate(-663.513 -227.762)"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUserBrand, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/UserBrand.8ee57357.svg";
export { ForwardRef as ReactComponent };